import React, { Component } from "react"
import "url-search-params-polyfill"

class RedirectAds extends Component {
  componentDidMount() {
    this.getRedirectParams()
  }

  getRedirectParams = async () => {
    const {
      location: { search },
    } = this.props
    const params = new URLSearchParams(search)
    const redirectParams = params.get("redirect")
    console.log(redirectParams)
    localStorage.setItem("redirectParam", redirectParams)
    
    document.location.href = "https://www.lit.com.br/"
  }

  render() {
    return <div />
  }
}

export default RedirectAds
